export const theme = {
  colors: {
    dark: '#14213d',
    darkSoft: '#000000',
    accent: '#fca311',
    accentSoft: '#e5e5e5',
    light: '#ffffff',
    paper: '#ffffff',
    paperWarm: '#f7f7f7',
    surface: '#e5e5e5',
    pageStart: '#ffffff',
    pageMid: '#f7f7f7',
    pageEnd: '#e5e5e5',
  },
  shadow: 'rgba(20, 33, 61, 0.14)',
} as const;

export const themeCssVariables = `
  :root {
    --theme-light: ${theme.colors.light};
    --theme-accent-soft: ${theme.colors.accentSoft};
    --theme-accent: ${theme.colors.accent};
    --theme-dark: ${theme.colors.dark};
    --theme-dark-soft: ${theme.colors.darkSoft};
    --theme-paper: ${theme.colors.paper};
    --theme-paper-warm: ${theme.colors.paperWarm};
    --theme-surface: ${theme.colors.surface};
    --theme-page-start: ${theme.colors.pageStart};
    --theme-page-mid: ${theme.colors.pageMid};
    --theme-page-end: ${theme.colors.pageEnd};
    --theme-shadow: ${theme.shadow};
    --theme-accent-rgb: 252, 163, 17;
    --theme-accent-soft-rgb: 229, 229, 229;
  }
`;
